import { Component, inject } from '@angular/core';
import { GridStore } from '../../../stores/grid/grid.state';
import { Button, ButtonDirective } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-atlas-edit-button',
  standalone: true,
  imports: [ButtonDirective, TooltipModule, Button],
  templateUrl: './atlas-edit-button.component.html',
  styleUrl: './atlas-edit-button.component.scss',
})
export class AtlasEditButtonComponent {
  readonly gridStore = inject(GridStore);

  /**
   * Toggles the readonly state of the grid store. If the grid is currently readonly,
   * it will become editable, and if it is editable, it will become readonly.
   *
   * @return {void} Does not return a value.
   */
  editAtlasToggle() {
    this.gridStore.setReadonly(!this.gridStore.readonly());
  }
}
